"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _once = _interopRequireDefault(require("transmute/once"));

var setup = (0, _once.default)(function () {
  _jquery.default.extend(_jquery.default.fn.pickatime.defaults, {
    interval: 15,
    min: [0, 0],
    max: [23, 59],
    clear: ''
  });
});
var _default = setup;
exports.default = _default;
module.exports = exports.default;